module.exports = __webpack_public_path__ + "word_map.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/word_map.png
// module id = 1731
// module chunks = 11